import { FC, useState } from 'react'

import clsx from 'clsx'

import CloseIcon from '@mui/icons-material/Close'
import { Alert, Box, IconButton, Typography } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { IMAGES_PATH, useTheme } from 'themes'

import { newFormThemeOverrides } from '../styles'
import { IBaseAlert } from '../types'

const warningImg = IMAGES_PATH('/alert-warning.svg')
const infoImg = IMAGES_PATH('/alert-info.svg')
const errorImg = IMAGES_PATH('/alert-error.svg')

const Severity = {
    Warning: warningImg,
    Info: infoImg,
    Error: errorImg,
}

const severityToTypes = severityLevel => {
    switch (severityLevel) {
        case 'Low':
            return 'Info'
        case 'Medium':
            return 'Warning'
        default:
            return 'Error'
    }
}

const BaseAlert: FC<IBaseAlert> = ({ severity, dismissable, onDismiss, message, title }) => {
    const [open, setOpen] = useState(true)
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })

    const handleDismiss = () => {
        setOpen(false)
        onDismiss()
    }

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={open} timeout={500}>
                        <Alert
                            sx={{ mt: 1 }}
                            icon={false}
                            className={clsx(severityToTypes(severity), 'notification')}
                            action={
                                dismissable && (
                                    <IconButton
                                        className="alertDismiss"
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={handleDismiss}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                )
                            }
                        >
                            <div className="iconBox">
                                <img className="iconImg" src={Severity[severityToTypes(severity)]} alt={severity} />
                            </div>
                            <Box sx={{ p: '10px 20px' }}>
                                <Typography className="type">{title}</Typography>
                                <Box>{message}</Box>
                            </Box>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default BaseAlert
